import { Components } from 'react-markdown';

import * as S from './style';

import { ContentType } from './types';

const getComponents = (contentType: ContentType): Components => {
  const components: Record<ContentType, Components> = {
    primary: {
      p: S.PrimaryContentText as Components['p'],
      pre: S.PrimaryContentText as Components['pre'],
      b: S.PrimaryContentHighlight as Components['b'],
      strong: S.PrimaryContentHighlight as Components['strong'],
      a: (props: React.HTMLAttributes<HTMLAnchorElement>) => (
        <S.PrimaryContentLink {...props} target="_blank" />
      ),
      h1: S.PrimaryContentSubtitle as Components['h1'],
      h2: S.PrimaryContentSubtitle as Components['h2'],
      h3: S.PrimaryContentSubtitle as Components['h3'],
      h4: S.PrimaryContentSubtitle as Components['h4'],
      h5: S.PrimaryContentSubtitle as Components['h5'],
      h6: S.PrimaryContentSubtitle as Components['h6'],
      ol: S.PrimaryContentOrderedList as Components['ol'],
      ul: S.PrimaryContentList as Components['ul'],
      li: S.PrimaryContentListItem as Components['li'],
      img: S.PrimaryContentImage as Components['img'],
      iframe: S.PrimaryContentIframe as Components['iframe'],
      div: S.PrimaryContentDiv as Components['div'],
    },
    secondary: {
      p: S.SecondaryContentText as Components['p'],
      pre: S.SecondaryContentText as Components['pre'],
      b: S.SecondaryContentHighlight as Components['b'],
      strong: S.SecondaryContentHighlight as Components['strong'],
      a: (props: React.HTMLAttributes<HTMLAnchorElement>) => (
        <S.SecondaryContentLink {...props} target="_blank" />
      ),
      h1: S.SecondaryContentSubtitle as Components['h1'],
      h2: S.SecondaryContentSubtitle as Components['h2'],
      h3: S.SecondaryContentSubtitle as Components['h3'],
      h4: S.SecondaryContentSubtitle as Components['h4'],
      h5: S.SecondaryContentSubtitle as Components['h5'],
      h6: S.SecondaryContentSubtitle as Components['h6'],
      ol: S.SecondaryContentList as Components['ol'],
      ul: S.SecondaryContentList as Components['ul'],
      li: S.SecondaryContentListItem as Components['li'],
    },
  };

  return components[contentType];
};
const allowedElements = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'br',
  'b',
  'div',
  'i',
  'strong',
  'em',
  'a',
  'pre',
  'code',
  'img',
  'iframe',
  'p',
  'ol',
  'ul',
  'table',
  'thead',
  'tbody',
  'tfoot',
  'blockquote',
  'hr',
  'li',
  'tr',
  'td',
  'abbr',
  'small',
  'span',
  'time',
  'u',
];

export { getComponents, allowedElements };
